import React, { createContext, useEffect, useState, ReactNode } from "react";
import Keycloak from "keycloak-js/lib/keycloak";
import keycloak from "../keycloak";

interface KeycloakContextProps {
    keycloak: Keycloak;
    initialized: boolean;
}

export const KeycloakContext = createContext<KeycloakContextProps | null>(null);

export const KeycloakProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        keycloak.init({
            onLoad: "login-required",
            checkLoginIframe: false,
        })
            .then((authenticated: any) => {
                if (!authenticated) {
                    keycloak.login().then(console.log);
                } else {
                    const tokenParsed = keycloak.tokenParsed;
                    if (tokenParsed?.api_key) {
                        setInitialized(true);
                        console.log("API key attribute found:", tokenParsed.api_key);
                    } else {
                        console.warn("API key attribute not found in token.");
                        keycloak.logout().then(console.log);
                        keycloak.login().then(console.log);
                    }

                }
            })
            .catch(console.error);
    }, []);

    if (!initialized) return <div>Loading...</div>;

    return (
        <KeycloakContext.Provider value={{ keycloak, initialized }}>
            {children}
        </KeycloakContext.Provider>
    );
};